import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectStripe } from 'react-stripe-elements';
import get from 'lodash.get';

import { setPaymentStarted, makePaymentErrorOccured, onValueChange, makePaymentRequest } from '../reducer';

import { getCustomFields, getPhoneNumberFromFormbuilderAnswers, getAddressModelFromFormbuilderAnswers } from '../../../helpers/formBuilderHelper';
import { DeviceHelper } from '../../../helpers/deviceHelper';

import { Form } from 'semantic-ui-react';
import DonationErrorMessage from './donationErrorMessage';
import DonateButton from './donationButton';
import { InjectReCaptcha } from '../../../components/common/reCaptcha';

import { loadingStatus } from '../../../constants/loading';
import { MAX_DONATION_VALUE } from '../../../constants';
import { erorrMessages } from '../constants/errorMessages';
import { paths } from '../constants';
import { RECAPTCHA_SITE_KEY } from '../../../env';
import { displayNameKeys } from '../../../constants/displayNameOptions';
import { DonationType } from '../../../constants/donationType';

import './index.css';

export class PledgePaymentFormContainer extends React.Component {
    componentDidUpdate() {
        if (this.props.donation.paymentInProgress === loadingStatus.SUCCESS) {
            if (this.props.match.url.endsWith('/')) {
                this.props.history.push(`${this.props.match.url}thankyou`);
            } else {
                this.props.history.push(`${this.props.match.url}/thankyou`);
            }
        }
    }

    isValid = () => {
        let isTabsValid = true;

        for (let prop in this.props.tabsValidation) {
            isTabsValid = isTabsValid && this.props.tabsValidation[prop];
        }

        const isTooMuchValue = this.isTooMuchValue();

        return isTabsValid && !isTooMuchValue;
    }

    handleSubmit = ev => {
        if (this.isValid()) {
            const win = window;

            if (RECAPTCHA_SITE_KEY && win.grecaptcha) {
                win.grecaptcha.ready(_ => {
                    win.grecaptcha
                        .execute(RECAPTCHA_SITE_KEY, { action: "donate" })
                        .then(token => {
                            this.proceedSubmit(ev, token);
                        })
                })
            }
            else {
                this.proceedSubmit(ev);
            }
        }
    }

    proceedSubmit = (ev, verificationToken = null) => {
        this.props.setPaymentStarted();

        ev.preventDefault();

        this.submitPayment(verificationToken);
    };

    getTemplateModel = () => {
        return {
            key: null,
            value: {
            }
        };
    };

    getDisplayName = () => {
        const displayNameOption = get(this.props.donation, paths.SELECTED_DISPLAY_NAME_OPTION);

        return displayNameOption === displayNameKeys.asCustomName ? get(this.props, 'donation.displayName') : null;
    };

    submitPayment = verificationToken => {
        const { formbuilderAnswers } = this.props.donation;
        const donation = {
            template: this.getTemplateModel(),
            amount: this.props.donation.amount,
            message: this.props.donation.message,
            pageType: 1,
            fields: getCustomFields(formbuilderAnswers),
            type: DonationType.Pledge,
            organizationId: get(this.props, 'page.organization.id'),
            campaignId: get(this.props, 'page.campaign.id'),
            displayName: this.getDisplayName(),
            device: {
                type: DeviceHelper.getDeviceType(),
                platform: DeviceHelper.getDevicePlatform()
            },
            customer: {
                salutation: this.props.donation.customer.salutation,
                email: this.props.donation.customer.email,
                firstName: this.props.donation.customer.firstName,
                lastName: this.props.donation.customer.lastName,
                anonymous: this.props.donation.customer.anonymous,
                businessName: this.props.donation.customer.isBehalfOfCompany ? this.props.donation.customer.businessName : null,
                newsletter: this.props.donation.customer.newsletter,
                phoneNumber: getPhoneNumberFromFormbuilderAnswers(formbuilderAnswers),
                address: getAddressModelFromFormbuilderAnswers(formbuilderAnswers)
            },
            issueReceipt: true
        };

        this.props.makePayment(donation, this.props.donation.idempotencyKey, verificationToken);
    };

    isTooMuchValue = () => {
        return get(this.props, 'donation.paymentRequestAmount') > MAX_DONATION_VALUE;
    };

    render() {
        const isTooMuchValue = this.isTooMuchValue();

        return (
            <Form onSubmit={this.handleSubmit}>
                <div className="no-payment-label">
                    <label>
                        After you complete your pledge details, we will e-mail you your next steps!
                    </label>
                </div>

                <DonateButton disabled={isTooMuchValue} />

                {
                    isTooMuchValue &&
                    <DonationErrorMessage dismiss={false}
                        errorMessage={erorrMessages.MaxValueError} />
                }

                {
                    this.props.donation.serverErrorOccured &&
                    <DonationErrorMessage dismiss={true}
                        errorMessage={erorrMessages.ProcessingError} />
                }
            </Form>
        );
    }
}

const mapState = state => {
    return {
        donation: state.donation,
        page: state.page,
        tabsValidation: get(state, 'donation.tabsValidation')
    };
};

const mapDispatch = dispatch => {
    return {
        onValueChange(path, value) {
            dispatch(onValueChange(path, value));
        },
        makePayment: (donation, idempotencyKey, verificationToken) => {
            dispatch(makePaymentRequest(donation, idempotencyKey, verificationToken));
        },
        setPaymentStarted: () => {
            dispatch(setPaymentStarted());
        },
        makePaymentErrorOccured: error => {
            dispatch(makePaymentErrorOccured(error));
        }
    };
};
const PledgeMakePaymentForm =
    withRouter(connect(mapState, mapDispatch)
        (InjectReCaptcha(injectStripe(PledgePaymentFormContainer))));
export default PledgeMakePaymentForm;